import React, { useEffect, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import { alpha, makeStyles } from "@material-ui/core/styles";
import { InputAdornment } from "@material-ui/core";
import LocalStorageHelper from "../../common/localStorageHelper";
import * as timexHelper from "../../common/helper";

const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative",
        borderRadius: 200,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        "&:hover": {
            backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        margin: "auto",
        marginBottom: 10,

        width: "100%",
        height: 35,
        [theme.breakpoints.up("sm")]: {
            height: 30,
        },
        [theme.breakpoints.up("md")]: {
            height: 50,
        },
        [theme.breakpoints.up("lg")]: {
            height: 80,
            marginBottom: 20,
        },
        [theme.breakpoints.up("xl")]: {
            height: 80,
            marginBottom: 20,
        },
    },
    input: {
        padding: theme.spacing(1.5, 2),
        width: "100%",
        textAlign: "center",
        color: "white",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
    },
    searchIcon: {
        color: "white",
    },
}));

const useDebouncedValue = (inputValue, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(inputValue);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(inputValue);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [inputValue, delay]);

    return debouncedValue;
};

export default function SearchBar({ flightDetails, flightFilters, setFlightDetails }) {
    const classes = useStyles();
    const [searchValue, setSearchValue] = useState("");
    const debouncedSearchSearchValue = useDebouncedValue(searchValue, 500);

    useEffect(() => {
        let filters = LocalStorageHelper.appliedFilters.get() ?? timexHelper.GetDefaultFlightFilters();
        filters.flightOrTailNumberSearch = debouncedSearchSearchValue;

        LocalStorageHelper.appliedFilters.set(filters);
        setFlightDetails({ flightDetails }, filters);
    }, [debouncedSearchSearchValue]);

    const handleChange = (event) => {
        const { value } = event.target;

        // restrict input value to numbers
        if (/^[0-9]*$/.test(value)) {
            setSearchValue(value);
        }
    };

    return (
        <div className={classes.root} data-testid="search-bar">
            <InputBase
                placeholder="Search by flight number or tail number..."
                className={classes.input}
                startAdornment={
                    <InputAdornment position="start" className={classes.searchIcon}>
                        <SearchIcon />
                    </InputAdornment>
                }
                value={searchValue}
                onChange={handleChange}
            />
        </div>
    );
}
